import React from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/styles';
import SwipeableViews from 'hb-react-swipeable-views-new';
import {
  Grid, Button, Dialog, DialogTitle, DialogActions, DialogContent,
  List, ListItem, ListItemText, ListItemIcon, IconButton, Tab,
  Tabs, Box, AppBar
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import logo from 'dataModule/assets/img/HealthBeatsDialogLogo.svg';
import helpAndSupport from 'dataModule/assets/img/customerServiceSupport/helpAndSupport.svg';
import serviceContact from 'dataModule/assets/img/customerServiceSupport/serviceContact.svg';
import serviceEmail from 'dataModule/assets/img/customerServiceSupport/serviceEmail.svg';
import serviceLocation from 'dataModule/assets/img/customerServiceSupport/serviceLocation.svg';

const styles = theme => ({
  dialogPaper: {
    minHeight: '600px',
    minWidth: '654px',
    borderRadius: '5px'
  },
  topHeader: {
    margin: 0,
    padding: 2,
    height: 64,
    backgroundColor: '#fff',
  },
  primaryColor: {
    color: '#ff5100',
  },
  listItem: {
    height: 'auto !important',
  },
  dialogLogo: {
    maxWidth: '40px'
  },
  dialogTitle: {
    color: '#212121',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '19px',
    letterSpacing: '0.15000000596046448px',
  },
  dialogCloseButton: {
    position: 'relative',
    left: '10px',
    color: 'black',
    maxHeight: '40px',
    maxWidth: '40px'
  },
  dialogDisplayFlex: {
    display: 'flex',
    alignItems: 'center',
    maxHeight: '40px',
    textIndent: 0
  },
  dialogListItem: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '19px',
    color: '#212121',
    letterSpacing: '0.5px'
  },
  link: {
    marginLeft: 30,
  },
  icon: {
    marginRight: 8,
  },
  button: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '1.25px',
    textAlign: 'center',
    minWidth: 161,
  },
  tabRoot: {
    [theme.breakpoints.up('md')]: {
      minWidth: 80,
    },
    backgroundColor: '#fff',
    opacity: 'unset',
    height: 60,
    '&:hover': {
      color: '#2979ff',
      opacity: 1,
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  tabLabelContainer: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(),
      paddingRight: theme.spacing(),
    },
  },
  label: {
    textTransform: 'capitalize',
    color: '#212121',
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: 1.2,
    fontStretch: 'normal',
    letterSpacing: '0.5px',
    '&:hover': {
      color: '#212121',
    },
  },
  indicator: { backgroundColor: '#ff5100' },
});
class TabPanel extends React.Component {
  render() {
    const { children, value, index, ...other } = this.props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
}

@withNamespaces('common', { wait: true })
@withStyles(styles, { index: 1 })
export default class DialogCustomerSupportContactComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
    };
  }

  handleClose = async () => {
    this.props.toggledialogCustomerSupportContact(false);
  }

  handleChange = (event, newValue) => {
    this.setState({ selectedTab: newValue });
  };

  handleChangeIndex = (index) => {
    this.setState({ selectedTab: index });
  };

  a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  };

  render() {
    const {
      t,
      open,
      classes: { dialogPaper, dialogLogo, dialogDisplayFlex, button, dialogTitle, dialogCloseButton, dialogListItem, indicator, tabRoot, tabLabelContainer, listItem, label },
    } = this.props;

    return (
      <Dialog
        open={open}
        classes={{ paper: dialogPaper }}
        aria-labelledby='ihealth-customer-care-info'
      >
        <DialogTitle id='ihealth-customer-care-info' style={{ padding: '12px 16px' }}>
          <Grid container direction="row" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Grid item className={dialogDisplayFlex}>
              <img src={logo} className={dialogLogo} />
              <span style={{ width: '16px' }} />
              <Typography variant="body1" className={dialogTitle}>
                {t('customerServiceSupportDialog.title')}
              </Typography>
            </Grid>
            <Grid item className={dialogDisplayFlex}>
              <IconButton aria-label="close" className={dialogCloseButton} onClick={this.handleClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ padding: '0' }}>
          <AppBar position="static" color="default">
            <Tabs
              value={this.state.selectedTab}
              onChange={this.handleChange}
              classes={{ indicator: indicator, backgroundColor: '#E0E0E0' }}
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label={
                <Typography variant='subtitle1' className={label} style={{ color: this.state.selectedTab === 0 ? '#ff5100' : '#9E9E9E' }}>
                  {t('customerServiceSupportDialog.singapore')}
                </Typography>
              } {...this.a11yProps(0)} classes={{
                root: tabRoot,
                wrapper: tabLabelContainer,
              }} />
              <Tab label={
                <Typography variant='subtitle1' className={label} style={{ color: this.state.selectedTab === 1 ? '#ff5100' : '#9E9E9E' }}>
                  {t('customerServiceSupportDialog.australia')}
                </Typography>
              } {...this.a11yProps(1)} classes={{
                root: tabRoot,
                wrapper: tabLabelContainer,
              }} />
              <Tab label={
                <Typography variant='subtitle1' className={label} style={{ color: this.state.selectedTab === 2 ? '#ff5100' : '#9E9E9E' }}>
                  {t('customerServiceSupportDialog.unitedStates')}
                </Typography>
              } {...this.a11yProps(2)} classes={{
                root: tabRoot,
                wrapper: tabLabelContainer,
              }} />
            </Tabs>
          </AppBar>

          <SwipeableViews
            index={this.state.selectedTab}
            onChangeIndex={this.handleChangeIndex}
          >
            <TabPanel value={this.state.selectedTab} index={0} >
              <List>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={helpAndSupport} />
                  </ListItemIcon>
                  <ListItemText
                    style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }}
                    primary={
                      <React.Fragment>
                        <Typography variant='body1' className={dialogListItem}>
                          {t('customerServiceSupportDialog.content.001')} <a href="https://healthbeats.co/support">{t('customerServiceSupportDialog.content.002')}</a>
                        </Typography>
                      </React.Fragment>
                    } secondary={<Typography variant='body1' className={dialogListItem}>{t('customerServiceSupportDialog.content.003')}</Typography>} />
                </ListItem>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={serviceEmail} />
                  </ListItemIcon>
                  <ListItemText style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }} primary={
                    <React.Fragment>
                      <Typography variant='body1' className={dialogListItem}>
                        <a href="mailto:support@healthbeats.co">support@healthbeats.co</a>
                      </Typography>
                    </React.Fragment>
                  } />
                </ListItem>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={serviceContact} />
                  </ListItemIcon>
                  <ListItemText
                    style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }}
                    primary={<Typography variant='body1' className={dialogListItem}>+65 9721 0633</Typography>} />
                </ListItem>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={serviceLocation} />
                  </ListItemIcon>
                  <ListItemText
                    style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }}
                    primary={<Typography variant='body1' className={dialogListItem}>{t('customerServiceSupportDialog.address.singapore')}</Typography>} />
                </ListItem>
              </List>
            </TabPanel>
            <TabPanel value={this.state.selectedTab} index={1} >
              <List>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={helpAndSupport} />
                  </ListItemIcon>
                  <ListItemText
                    style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }}
                    primary={
                      <React.Fragment>
                        <Typography variant='body1' className={dialogListItem}>
                          {t('customerServiceSupportDialog.content.001')} <a href="https://healthbeats.co/support">{t('customerServiceSupportDialog.content.002')}</a>
                        </Typography>
                      </React.Fragment>
                    } secondary={<Typography variant='body1' className={dialogListItem}>{t('customerServiceSupportDialog.content.003')}</Typography>} />
                </ListItem>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={serviceEmail} />
                  </ListItemIcon>
                  <ListItemText style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }} primary={
                    <React.Fragment>
                      <Typography variant='body1' className={dialogListItem}>
                        <a href="mailto:support@healthbeats.co">support@healthbeats.co</a>
                      </Typography>
                    </React.Fragment>
                  } />
                </ListItem>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={serviceContact} />
                  </ListItemIcon>
                  <ListItemText
                    style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }}
                    primary={<Typography variant='body1' className={dialogListItem}>+61 403 266 068</Typography>} />
                </ListItem>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={serviceLocation} />
                  </ListItemIcon>
                  <ListItemText
                    style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }}
                    primary={<Typography variant='body1' className={dialogListItem}>{t('customerServiceSupportDialog.address.australia')}</Typography>} />
                </ListItem>
              </List>
            </TabPanel>
            <TabPanel value={this.state.selectedTab} index={2} >
              <List>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={helpAndSupport} />
                  </ListItemIcon>
                  <ListItemText
                    style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }}
                    primary={
                      <React.Fragment>
                        <Typography variant='body1' className={dialogListItem}>
                          {t('customerServiceSupportDialog.content.001')} <a href="https://healthbeats.co/support">{t('customerServiceSupportDialog.content.002')}</a>
                        </Typography>
                      </React.Fragment>
                    } secondary={<Typography variant='body1' className={dialogListItem}>{t('customerServiceSupportDialog.content.003')}</Typography>} />
                </ListItem>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={serviceEmail} />
                  </ListItemIcon>
                  <ListItemText style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }} primary={
                    <React.Fragment>
                      <Typography variant='body1' className={dialogListItem}>
                        <a href="mailto:support@healthbeats.co">support@healthbeats.co</a>
                      </Typography>
                    </React.Fragment>
                  } />
                </ListItem>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={serviceContact} />
                  </ListItemIcon>
                  <ListItemText
                    style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }}
                    primary={<Typography variant='body1' className={dialogListItem}>+65 9640 6780</Typography>} />
                </ListItem>
                <ListItem className={listItem}>
                  <ListItemIcon style={{ color: '#212121', paddingBottom: 20 }}>
                    <img src={serviceLocation} />
                  </ListItemIcon>
                  <ListItemText
                    style={{ whiteSpace: 'break-spaces', paddingBottom: 20 }}
                    primary={<Typography variant='body1' className={dialogListItem}>{t('customerServiceSupportDialog.address.unitedStates')}</Typography>} />
                </ListItem>
              </List>
            </TabPanel>
          </SwipeableViews>

        </DialogContent>
        <DialogActions style={{ padding: '12px' }}>
          <Button className={['milo-btn-orange', button]} variant='contained' onClick={this.handleClose}>
            {t('common:buttonLabels.ok')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
